export const Enums = Object.freeze({
    
    // Roles
    //------------------------
    Roles: {
        NHQNationalPracticeDataSteward: { id:1, key:"NHQNationalPracticeDataSteward", display:"NHQ National Practice Data Steward" },
        NHQNationalReportingDataSteward: { id:3, key:"NHQNationalReportingDataSteward", display:"NHQ National Reporting Data Steward" },
        StateDataSteward: { id:4, key:"StateDataSteward", display:"State Data Steward" },
        LocalDataSteward: { id:5, key:"LocalDataSteward", display:"Local Data Steward" },
        DataViewer: { id:6, key:"DataViewer", display:"Data Viewer" },
        TechSupport: { id:7, key:"TechSupport", display:"CPDES Technical Support" },
        NationalDisciplineDataSteward: { id:9, key:"NationalDisciplineDataSteward", display:"National Discipline Data Steward" }

        //Roles deprecated (keep untill all refs removed from outoging code)
        ,NHQNationalActivityDataSteward: { id:2, key:"NHQNationalActivityDataSteward", display:"NHQ National Activity Data Steward" }
        ,CPPENationalDataSteward: { id:8, key:"CPPENationalDataSteward", display:"CAPP National Data Steward" }
    },


    // RolesById
    //------------------------
    RolesById: {
        1: { id:1, key:"NHQNationalPracticeDataSteward", display:"NHQ National Practice Data Steward" },
        3: { id:3, key:"NHQNationalReportingDataSteward", display:"NHQ National Reporting Data Steward" },
        4: { id:4, key:"StateDataSteward", display:"State Data Steward" },
        5: { id:5, key:"LocalDataSteward", display:"Local Data Steward" },
        6: { id:6, key:"DataViewer", display:"Data Viewer" },
        7: { id:7, key:"TechSupport", display:"CPDES Technical Support" },
        9: { id:9, key:"NationalDisciplineDataSteward", display:"National Discipline Data Steward" }

        //Roles deprecated (keep untill all refs removed from outoging code)
        ,2: { id:2, key:"NHQNationalActivityDataSteward", display:"NHQ National Activity Data Steward" }
        ,8: { id:8, key:"CPPENationalDataSteward", display:"CAPP National Data Steward" }
    },

    FeatureFlags: {
        AdvancedTagging: "METISART-4131",
        ClimateSmart: "METISART-1607",
        COMETPlanner: "BASECAMP-283",
        EmailService: "METISART-2240",
        TaggingManagement: "METISART-4311",
        LanguageTranslation: "METISART-4919"

        //Previous Feature Flags no longer needed
        //AssetTypeManagement: "63557",
        //PurposeManagementModule: "BASECAMP-91",
        //StateCAPPAccess: "BASECAMP-236",
        //RCCLUExport: "BASECAMP-404",
        //AssetHistory: "BASECAMP-397",
        //StateResourceManagementAccess: "METISART-1608",
        //DV1InsertAsset: "METISART-1910",
        //RCCLUAssociationFY: "METISART-2359",
        //DV1UpdateAsset: "METISART-2554"
    },

    ATCFlags: {
        MANAGE_PURPOSES: 0x01,     //1st bit
        FSA_PRACTICE: 0x02         //2nd bit
    }

});